// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-container[data-v-996791e2] .el-collapse-item__header {\n  font-size: 20px;\n  color: red;\n}\n", ""]);
// Exports
module.exports = exports;
